module.exports = __webpack_public_path__ + "files/Borang_KWSP_17A_(Khas_2021).xlsx";


//////////////////
// WEBPACK FOOTER
// ./files/Borang_KWSP_17A_(Khas_2021).xlsx
// module id = 1136
// module chunks = 1